import {createFileRoute} from '@tanstack/react-router';
import {ZendeskLogoutPage} from 'features/zendesk/ZendeskLogoutPage';

export const Route = createFileRoute('/zendesk/logout')({
  component: ZendeskLogoutPage,
});
